export const selectAuthStatus = state => state.auth.isAuthenticated

export const selectUserRole = state => state.auth.user?.role
